import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ExtendedProcedureFormBase } from '../../model/procedure/extended-procedure-form.model';
import { Page } from '../../model/filter/page.model';
import { PageResult } from '../../model/filter/page-result.model';
import { ProcedureFormFilterBase } from '../../model/procedure/procedure-form-filter.model';

@Injectable({
    providedIn: 'root'
})
export class ProcedureFormService {

    protected resourceUrl: string = "/rest/adminens/procedureForm"

    constructor(private http: HttpClient) { }

    // TODO : Update this will not work without admin
    public searchProcedure(filter: ProcedureFormFilterBase, generic?: boolean): Observable<Page<ExtendedProcedureFormBase>> {
        
        let url = "findProcedure"
        if (generic != null && generic == true) {
            url = "findGenericProcedure"
        }

        return this.http.post<PageResult<ExtendedProcedureFormBase>>(`${this.resourceUrl}/${url}`, filter).pipe(map(r => {
            let epf: ExtendedProcedureFormBase[] = []
            r.pageResult.content.forEach(p => {
                epf.push(ExtendedProcedureFormBase.from(p))
            })
            r.pageResult.content = epf
            return r.pageResult
        }))

    }


}
